import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VoicemailFieldConfig, VoicemailFieldConfigRequest } from '../models/generated/ziroModels';

@Injectable()
export class VoicemailFieldsConfigResource {
  protected http = inject(HttpClient);

  protected _baseUrl = '/services/cisco/field-configs/voicemails';

  post(body: VoicemailFieldConfigRequest): Observable<VoicemailFieldConfig> {
    return this.http.post<VoicemailFieldConfig>(this._baseUrl, body);
  }
}
